import { EnergySavingUI } from "./EnergySavingUI";
import { StandardProps } from "../componentMap";

export function EnergySaving({
  product,
  flags,
}: Pick<StandardProps, "product" | "flags">) {
  const isYourekoApi = flags["youreko-api"].value;

  if (!isYourekoApi) return null;

  return <EnergySavingUI product={product} />;
}
